module.exports = __webpack_public_path__ + "static/media/tick.9ddedf71.svg";